import type { Tool } from './Tool';
import { Grid } from '../Grid';

export abstract class BaseBrush implements Tool {
    abstract name: string;

    apply(x: number, y: number, grid: Grid, size: number): void {
        for (let dy = -size; dy <= size; dy++) {
            for (let dx = -size; dx <= size; dx++) {
                const targetX = x + dx;
                const targetY = y + dy;
                
                if (targetX >= 0 && targetX < grid.width && targetY >= 0 && targetY < grid.height) {
                    // 传入距离信息用于概率计算
                    // 改为切比雪夫距离以支持正方形笔刷的均匀衰减
                    const dist = Math.max(Math.abs(dx), Math.abs(dy));
                    this.applyAt(targetX, targetY, grid, dist, size);
                }
            }
        }
    }

    protected abstract applyAt(x: number, y: number, grid: Grid, dist: number, maxDist: number): void;
}
